module.exports = __webpack_public_path__ + "static/ulanka-MONEI-ff060f14303a0b1592ab12ed3b4d150a.png";